import { Splide } from "@splidejs/splide";

import "./brands-slider.scss";

export class BrandsSlider {
    #SELECTOR_SLIDER = '.brands-slider';

    #slider: Splide;

    constructor() {
        this.#initElements();
        this.#initEvents();

        this.#slider.mount();

        this.#tweakSlider();
    }

    #initElements(): void {
        this.#slider = new Splide(this.#SELECTOR_SLIDER, {
            perPage: 1,
            focus: 'center',
            pagination: false,
            keyboard: true,
            slideFocus: true,
            trimSpace: false,
            mediaQuery: 'min',
            breakpoints: {
                576: {
                    perPage: 2,
                    focus: undefined,
                    trimSpace: true,
                },
                768: {
                    perPage: 3,
                },
                992: {
                    perPage: 4,
                },
                1200: {
                    perPage: 5,
                },
            }
        });
    }

    #initEvents(): void {
    }

    #tweakSlider(): void {
    }
}
